import {Navigate, useParams, useSearchParams} from 'react-router-dom';

/**
 * Group members are now shown on the global Member Search page (`/member-search`)
 * pre-filtered to the group, instead of a separate nested per-group list. This
 * component preserves the legacy `/groups/:groupId/members` route — and every
 * remaining link that still points at it (member detail "Back to members",
 * post-add/import navigation, bookmarks) — by redirecting to Member Search with
 * the group pinned, carrying over the old filter query params.
 */
export const GroupMembers = () => {
  const {groupId} = useParams<{groupId: string}>();
  const [searchParams] = useSearchParams();

  if (!groupId) {
    return <Navigate to='/member-search' replace />;
  }

  const params = new URLSearchParams();
  params.set('groupId', groupId);

  // Map legacy GroupMembers query params onto the Member Search URL state.
  const search = searchParams.get('search');
  if (search) params.set('q', search);

  const relationship = searchParams.get('relationship');
  if (relationship) params.set('relationship', relationship);

  const status = searchParams.get('status');
  if (status === 'active') params.set('activeStatus', 'active');
  else if (status === 'termed') params.set('activeStatus', 'terminated');

  const page = searchParams.get('page');
  if (page) params.set('page', page);

  return <Navigate to={`/member-search?${params.toString()}`} replace />;
};
